import { LinkField, TextField, useFieldHelper } from 'framework/ui/field';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useProjectSecurityContext,
  useNewProjectUrl,
} from 'domain/shared/newProject';

interface TaskPreviewLinkFieldProps {
  projectId: string;
  idSource: string;
  aliasSource: string;
}

const TaskPreviewLinkField = ({ projectId, idSource, aliasSource = '' }: TaskPreviewLinkFieldProps) => {
  const { getValue: getIdValue } = useFieldHelper({ source: idSource });
  const { getValue: getAliasValue } = useFieldHelper({ source: aliasSource });
  const { getValue: getProjectId } = useFieldHelper({ source: projectId });

  const { getProjectClientPortalViewUrl } = useNewProjectUrl();
  const taskId = getIdValue();
  const project = getProjectId();
  const { isAccessGranted } = useProjectSecurityContext();

  const canManageTask = isAccessGranted(ACCESS_INFO_SECTIONS.CLIENT_PORTAL, ACCESS_INFO_ACTIONS.MANAGE);

  if (!canManageTask) {
    return <TextField value={getAliasValue()} />;
  }

  return <LinkField isInternal value={getProjectClientPortalViewUrl(project, taskId)} linkText={getAliasValue()} />;
};

export default TaskPreviewLinkField;
